import { createContext } from "react";

const CatResultContext = createContext(undefined as any);

export default CatResultContext;
